module.exports = __webpack_public_path__ + "static/media/destaque-linhas-corporal.4e8a3e40.jpg";